<template>
  <div>
    <customize-page
      label-position="left"
      ref="page"
      inline
      :loading="loading"
      :data="dataList"
      :columns="columns"
      :pagination="pagination"
      :formConfig="getFormConfig()"
      :filterObj="filterObj"
      :hideOperate="true"
      @size-change="handleSizeChange"
    >
      <div slot="footer">
        <el-button style="margin-right: 10px" type="primary" @click="search">
          搜索
        </el-button>
        <el-button style="margin-right: 10px" @click="reset">重置</el-button>
        <el-button style="margin-right: 10px" type="primary" @click="adjust">
          库存调整
        </el-button>
      </div>
    </customize-page>
    <GoodsSelectDialog
      :visible.sync="dialogVisible"
      @close="close"
      @on-select="handleSelect"
    />
    <el-dialog
      title="调整库存"
      width="500px"
      :visible.sync="stockDialogVisible"
      :before-close="closeStockDialog"
    >
      <el-form
        style="width: 400px;"
        ref="form"
        :model="form"
        label-width="140px"
        :rules="rules"
      >
        <el-form-item label="商品名称">
          {{ form.declareName }}
        </el-form-item>
        <el-form-item label="商品料号">
          {{ form.itemNo }}
        </el-form-item>
        <el-form-item label="备案序号">
          {{ form.itemRecordNo }}
        </el-form-item>
        <el-form-item label="调整前仓库数量">
          {{ form.beforeWmsNum }}
        </el-form-item>
        <el-form-item label="调整前海关数量">
          {{ form.beforeStockCustomsNum }}
        </el-form-item>
        <el-form-item label="调整前冻结库存">
          {{ form.beforeStockFreezeNum }}
        </el-form-item>
        <el-form-item prop="afterWmsNum" label="调整后仓库数量">
          <el-input-number
            style="width: 100px"
            :controls="false"
            :precision="0"
            v-model.number="form.afterWmsNum"
            placeholder="调整后仓库数量"
          />
        </el-form-item>
        <el-form-item prop="afterStockCustomsNum" label="调整后海关数量">
          <el-input-number
            style="width: 100px"
            :controls="false"
            :precision="0"
            v-model.number="form.afterStockCustomsNum"
            placeholder="调整后海关数量"
          />
        </el-form-item>
        <el-form-item prop="afterStockFreezeNum" label="调整后冻结库存">
          <el-input-number
            style="width: 100px"
            :controls="false"
            :precision="0"
            v-model.number="form.afterStockFreezeNum"
            placeholder="调整后冻结库存"
          />
        </el-form-item>
        <el-row type="flex" justify="center">
          <el-button type="primary" @click="submit">提交</el-button>
        </el-row>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import CustomizePage from "@/components/customize-page";
import Page from "@/mixin/Page";
import GoodsSelectDialog from "./components/GoodsSelectDialog.vue";

import { mapActions, mapState, mapGetters } from "vuex";

export default {
  components: {
    CustomizePage,
    GoodsSelectDialog
  },
  mixins: [Page],
  created() {
    let initParam = this.$store.state.app.sc["stockAdjustRecord"];
    if (initParam) {
      this.pagination.currentPage = initParam.request.pageIndex;
      this.pagination.pageSize = initParam.request.pageSize;
      this.filterObj = initParam.request.condition;
    }
  },
  mounted() {
    this.fetch();
  },
  data() {
    return {
      loading: false,
      dataList: [],
      currentStock: null,
      form: {},
      rules: {
        afterWmsNum: [
          { required: true, message: "请输入调整后仓库数量", trigger: "change" }
        ],
        afterStockCustomsNum: [
          { required: true, message: "请输入调整后海关数量", trigger: "change" }
        ],
        afterStockFreezeNum: [
          { required: true, message: "请输入调整后冻结库存", trigger: "change" }
        ]
      },
      columns: [
        {
          title: "货主id",
          key: "customerId",
          align: "center"
        },
        {
          title: "料号",
          key: "itemNo",
          align: "center"
        },
        {
          title: "备案序号",
          key: "itemRecordNo",
          align: "center"
        },
        {
          title: "备案名称",
          key: "declareName",
          align: "center"
        },
        {
          title: "调整前仓库库存",
          key: "beforeWmsNum",
          align: "center"
        },
        {
          title: "调整前海关数量",
          key: "beforeStockCustomsNum",
          align: "center"
        },
        {
          title: "调整前冻结库存",
          key: "beforeStockFreezeNum",
          align: "center"
        },
        {
          title: "调整后仓库数量",
          key: "afterWmsNum",
          align: "center"
        },
        {
          title: "调整后海关数量",
          key: "afterStockCustomsNum",
          align: "center"
        },
        {
          title: "调整后冻结库存",
          key: "afterStockFreezeNum",
          align: "center"
        },
        {
          title: "调整人",
          key: "adjustUserName",
          align: "center"
        },
        {
          title: "调整时间",
          key: "gmtCreate",
          align: "center"
        }
      ],
      filterObj: {
        customerId: "",
        declareName: "",
        itemNo: "",
        itemRecordNo: ""
      },
      dialogVisible: false,
      stockDialogVisible: false
    };
  },
  computed: {
    ...mapState("record", {
      list: "list"
    }),
    ...mapGetters({
      getCustomerList: "getCustomerList"
    })
  },
  methods: {
    ...mapActions("customsAccountBookStore", {
      adjustStockPageQuery: "adjustStockPageQuery",
      adjustStock: "adjustStock"
    }),
    handleSelect(row) {
      if (row) {
        this.currentStock = JSON.parse(JSON.stringify(row));
        this.form = {
          stockId: row.id,
          beforeWmsNum: row.wmsNum,
          beforeStockCustomsNum: row.stockCustomsNum,
          beforeStockFreezeNum: row.stockFreezeNum,
          declareName: row.declareName,
          itemNo: row.itemNo,
          itemRecordNo: row.itemRecordNo,
          afterWmsNum: row.wmsNum,
          afterStockCustomsNum: row.stockCustomsNum,
          afterStockFreezeNum: row.stockFreezeNum
        };
        this.stockDialogVisible = true;
      }
    },
    showDialog() {
      this.dialogVisible = true;
    },
    close() {
      this.dialogVisible = false;
    },
    closeStockDialog() {
      this.stockDialogVisible = false;
    },
    adjust() {
      this.showDialog();
    },
    submit() {
      this.$refs.form.validate(valid => {
        if (valid) {
          const tips = `是否确认调整库存？商品名称：${this.form.declareName}；商品料号：${this.form.itemNo};调整后仓库数量：${this.form.afterWmsNum};调整后海关数量：${this.form.afterStockCustomsNum};调整后冻结库存：${this.form.afterStockFreezeNum};`;
          this.$confirm(tips, "提示", {
            confirmButtonText: "确定"
          }).then(() => {
            this.adjustStock({
              request: {
                stockId: this.form.stockId,
                afterWmsNum: this.form.afterWmsNum,
                afterStockCustomsNum: this.form.afterStockCustomsNum,
                afterStockFreezeNum: this.form.afterStockFreezeNum
              }
            }).then(res => {
              if (res.value) {
                this.$message.success("调整成功");
                this.stockDialogVisible = false;
                setTimeout(() => {
                  this.currentStock = null;
                  this.form = {};
                }, 10);
                this.fetch();
              }
            });
          });
        }
      });
    },
    // 分页加载退货订单列表
    fetch() {
      this.loading = true;
      const filterParams = Object.assign({}, this.getFilterParams());
      let searchCondition = {
        request: {
          ...filterParams,
          pageInfo: {
            currentPage: this.pagination.currentPage,
            pageSize: this.pagination.pageSize
          }
        }
      };
      this.adjustStockPageQuery(searchCondition)
        .then(res => {
          this.loading = false;
          this.dataList = res.items || [];
          const pageInfo = res.pageInfo || { totalCount: 0 };
          this.pagination.totalCount = pageInfo.totalCount;
        })
        .catch(err => {
          this.loading = false;
        });
    },
    getFormConfig() {
      const type = this.getFormItemType();
      return [
        {
          data: [
            {
              label: "货主id",
              model: "customerId",
              type: type.SELECT,
              props: {
                data: this.getCustomerList
              }
            },
            {
              label: "备案名称",
              model: "declareName",
              type: type.INPUT
            },
            {
              label: "料号",
              model: "itemNo",
              type: type.INPUT
            },
            {
              label: "备案序号",
              model: "itemRecordNo",
              type: type.INPUT
            }
          ]
        }
      ];
    }
  }
};
</script>

<style>
.inline-p {
  display: inline-block;
}

.inline-p span {
  color: #3399ff;
}

.filter_con.filterUp .filter-form {
  height: auto;
  overflow: visible;
}
</style>
